import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FileProcessingService {

  constructor() { }

  attachmentChanged(file: File) : any{
    let reader = new FileReader();
    
    var ext : string[] = file.name.split(".");
    reader.readAsDataURL(file);
    reader.onload = () => {
      var fileObj = {fileName : file.name, fileData : (reader.result).toString().split(",")[1], fileType : file.type};
      console.log(fileObj);
      return fileObj;
    };
  }
}
